import { useTranslation } from 'react-i18next';
import { Card } from 'Card';
import { FilterControls } from './FilterControls';
import { type FilterControlsProps } from './FilterControls.types';
import { ScrollFadeContainer } from '../ScrollFadeContainer';
import '../../locales/studentNetworkV2/studentNetworkV2-en.json';

type PeopleFiltersSidebarProps = FilterControlsProps & {
    totalCount: number;
    isLoading: boolean;
};

const TAB_LABELS: Record<string, string> = {
    all: 'studentsAndAlumni',
    students: 'studentsOnly',
    alumni: 'alumniOnly',
    myClass: 'studentsOnly',
};

export function PeopleFiltersSidebar({ totalCount, isLoading, ...props }: PeopleFiltersSidebarProps) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'studentNetworkV2.studentNetworkV2.people' });

    return (
        <ScrollFadeContainer className="sticky top-0 hidden max-h-full w-[350px] shrink-0 self-start overflow-y-auto scrollbar-hide min-[1200px]:block min-[1400px]:w-[410px]">
            <Card padding={0} radius={8} className="mb-5">
                <div className="p-7.5">
                    <div className="relative mb-4 h-6 text-center text-base text-black">
                        <span
                            className={`absolute inset-0 transition-opacity duration-300 ${
                                isLoading ? 'opacity-100' : 'opacity-0'
                            }`}
                        >
                            {t('loading')}
                        </span>
                        <span
                            className={`absolute inset-0 transition-opacity duration-300 ${
                                isLoading ? 'opacity-0' : 'opacity-100'
                            }`}
                        >
                            {totalCount.toLocaleString()} {t(TAB_LABELS[props.activeTab] ?? 'studentsAndAlumni')}
                        </span>
                    </div>
                    <FilterControls {...props} />
                </div>
            </Card>
        </ScrollFadeContainer>
    );
}
